import { ExternalLinkIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import type { Editor } from '@generated/graphql';
import { useUserPreferences } from '@hooks/useUserPreferences';
import { useState, type MouseEventHandler } from 'react';
import { ServerLaunchOptionsMenu } from '../ServerLaunchOptionsMenu';
import { launchServer } from '../serverLaunchUtil';

export const ServerLaunchButton = ({ server }: { server: Editor }) => {
  const { preferredIDE } = useUserPreferences();
  const hasPreferredIDE = preferredIDE && preferredIDE !== 'none';

  const [launchAnchorEl, setLaunchAnchorEl] = useState<null | HTMLElement>(null);

  const handleServerLaunch: MouseEventHandler<HTMLElement> = (event) => {
    if (!hasPreferredIDE) {
      setLaunchAnchorEl(event.currentTarget);
    } else {
      launchServer({
        ide: preferredIDE,
        ...server,
      });
    }
  };

  if (server?.status?.state.toLowerCase() !== 'running') {
    return null;
  }
  return (
    <>
      <IconButton
        Icon={ExternalLinkIcon}
        size={16}
        tooltip="Open server"
        onClick={handleServerLaunch}
      />
      <ServerLaunchOptionsMenu
        anchorEl={launchAnchorEl}
        setAnchorEl={setLaunchAnchorEl}
        {...server}
      />
    </>
  );
};
